/**
 * Created by Steven-DESK on 15/06/2017.
 */
$(document).ready(function () {
    let regexMGSuc = /\/MijnGegevens\/(Save)|(Password)\/Success/;
    let regexLESuc = /\/leden\/index\/(Add)|(Delete)\/Success/;
    let regexEDSuc = /\/leden\/edit\/[0-9]+\/Save\/Success/;
    let regexMGFail = /\/MijnGegevens\/(Save)|(Password)\/Failed/;
    let regexLEFail = /\/leden\/index\/(Add)|(Delete)\/Failed/;
    let regexEDFail = /\/leden\/edit\/[0-9]+\/Save\/Failed/;
    let regexEDGFail = /\/leden\/edit\/[0-9]+\/Save\/Failed\/Gemeente/;
    let regexId = /\/edit\/([0-9]+)/;
    let errorGem = false;
    let errorTel = false;
    let errorGsm = false;
    let errorPw = true;
    let matches = regexId.exec(window.location.pathname);
    if (regexMGSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Mijn gegevens', '/MijnGegevens');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }

    if (regexMGFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Mijn gegevens', '/MijnGegevens');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }

    if (regexLESuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Leden', '/Leden');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }

    if (regexLEFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Leden', '/Leden');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexEDSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Bewerken',  '/Leden/edit/'+ matches[1]);
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexEDFail.test(window.location.pathname && !regexEDGFail.test(window.location.pathname))) {
        window.history.replaceState({}, 'KBSV - Bewerken', '/Leden/edit/'+ matches[1]);
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexEDGFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Bewerken', '/Leden/edit/'+ matches[1]);
        $(".save_fail_gem").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    $(".save_ok").click(function () {
        $(".save_fail").stop();
        $(".save_succ").stop();
        $(".verz_succ").stop();
        $(".canc_succ").stop();
        $(".save_fail_gem").stop();
        $(".save_fail_evi").stop();
        $(".delete_dyn_fail").stop();
        $(".inschr_aant_pers").stop();
        $(".save_fail_upload").stop();


    });

    $("#chk_gemeente").focusout(function () {
        let regexGem = /^[1-9][0-9]{3} [A-Z][a-zA-Z\-]+$/;
        if (regexGem.test($(this).val())) {
            $("#gem_err").hide();
            errorGem = false;
        } else {
            $("#gem_err").fadeIn(300);
            errorGem = true;
        }
    });

    $("#chk_gsm").focusout(function () {
        let regexGsm = /^0[0-9]{9}$/;
        if (regexGsm.test($(this).val()) || $(this).val().length === 0) {
            $("#gsm_err").hide();
            errorGsm = false;
        } else {
            $("#gsm_err").fadeIn(300);
            errorGsm = true;
        }
    });

    $("#chk_tel").focusout(function () {
        let regexTel = /^0[0-9]{8}$/;
        if (regexTel.test($(this).val()) || $(this).val().length === 0) {
            $("#tel_err").hide();
            errorTel = false;
        } else {
            $("#tel_err").fadeIn(300);
            errorTel = true;
        }
    });
    $("#alg_geg").submit(function (e) {
        if (errorTel || errorGsm || errorGem) {
            e.preventDefault();
        }
    });
    $("#led_add_form").submit(function (e) {
        if (errorTel || errorGsm || errorGem) {
            e.preventDefault();
        }
    });
    $("#led_edit_form").submit(function (e) {
        if (errorTel || errorGsm || errorGem) {
            e.preventDefault();
        }
    });

    $("#bevestig").keyup(function () {
        if ($(this).val() !== $("#nieuw").val()) {
            $("#pw_err").show();
            errorPw = true;
        } else {
            $("#pw_err").hide();
            errorPw = false;
        }
    });
    $("#nieuw").keyup(function () {
        if ($(this).val() !== $("#bevestig").val() && $("#bevestig").val().length !== 0) {
            $("#pw_err").show();
            errorPw = true;
        } else {
            $("#pw_err").hide();
            errorPw = false;
        }
    });

    $("#pw_chg").submit(function (e) {
        if (errorPw) {
            e.preventDefault();
        }
    })
});



//////////////////
// WEBPACK FOOTER
// ./js/leden.js
// module id = 20
// module chunks = 0